// extracted by mini-css-extract-plugin
export default {"root":"IconsCollection_root__c+Gzs"};